import { Component, Host, h, Prop, EventEmitter, Event, State } from '@stencil/core';
import { Consumes } from '@sydle/sydle-ui';
import { getAuthState } from '../sy-site-auth/store/store';

@Component({
  tag: 'sy-site-logout-dropdown-content',
  styleUrl: 'scss/sy-site-logout-dropdown-content.scss',
  shadow: true,
})
export class SySiteLogoutDropdownContent {
  @Consumes('siteAuth') @State() siteAuth: HTMLSySiteAuthElement;

  /**
   * Text used for logout button
   */
  @Prop() logoutText: string;

  /**
   * Event emitted on logout
   */
  @Event() sySiteLogoutDropdownContentDidLogout: EventEmitter;

  render() {
    const user = getAuthState('user');
    return (
      <Host>
        <sy-text type="h6">{user.name}</sy-text>
        <sy-divider></sy-divider>
        <sy-text
          type="h6"
          class="logout"
          onClick={() => {
            this.sySiteLogoutDropdownContentDidLogout.emit();
          }}
        >
          {this.logoutText}
        </sy-text>
      </Host>
    );
  }
}
